import React, { PureComponent } from 'react'
import { func } from 'prop-types'
import { Text } from '@chakra-ui/react'
import HtmlMarkdown from 'src/components/Render/HtmlMarkdown'
import { getBodyContainer, getBrandSettings, isEmpty } from 'src/utils/helpers'
import SvgIcon from 'src/components/SvgIcon'
import { Loader } from 'src/components/Loader'
import { FormattedMessage } from 'react-intl'
import { WidgetContext } from 'src/modules/App/WidgetContext'

// import Modal from 'src/components/Modal'
// import Button from 'src/components/Button'

import Button from 'src/components/Button/Button'

import styles from './styles.module.less'
import Modal from 'src/components/Modal/Modal'

class Disclaimer extends PureComponent {
  static propTypes = {
    onClose: func.isRequired,
    onSubmit: func.isRequired,
  }
  state = {
    isLoading: true,
    disclaimerMessage: null,
    afterHoursMessage: null,
    showAfterHours: this.props.isAfterHours,
  }

  componentDidMount() {
    this.loadCustomMessages()
  }

  /* componentDidUpdate(prevProps) {
    const { visible, onSubmit, afterHoursOnly } = this.props
    const { showAfterHours } = this.state

    if (prevProps.visible !== visible) {
      // Submit right away when checking only for "after hours" and it's not after hours
      if (afterHoursOnly === true && !showAfterHours && visible === true) {
        onSubmit()
      }
    }
  }*/

  loadCustomMessages = async () => {
    try {
      this.setState({
        isLoading: true,
      })

      const settings = await getBrandSettings('m')

      this.setState({
        disclaimerMessage: this.getMessageFromSettings(settings, 'disclaimerMessage'),
        afterHoursMessage: this.getMessageFromSettings(settings, 'afterHoursMessage'),
        isLoading: false,
      })
    } catch (e) {
      this.setState({
        isLoading: false,
      })
    }
  }

  getMessageFromSettings = (settings, messageName) => {
    try {
      // NOTE: PAT-3546 - For now only Claims disclaimer (when clicking on Report Claim option)
      // should get the custom message from backend. Later on remove the "showCustomMessage" prop
      // and replace it with some kind of "type" prop, so we know which custom message to show
      // (Claims, Add Driver, Remove Driver, Add Vehicle, Get Quote, etc...)
      const showCustomMessage =
        typeof this.props.showCustomMessage !== 'undefined' && this.props.showCustomMessage === true
      if (!showCustomMessage) {
        return null
      }

      if (
        settings &&
        settings.hasOwnProperty('messages') &&
        settings.messages &&
        settings.messages.hasOwnProperty(messageName) &&
        !isEmpty(settings.messages[messageName])
      ) {
        return settings.messages[messageName]
      }

      return null
    } catch (e) {
      return null
    }
  }

  closeModal = () => {
    // If it's after hours disclaimer, we should just hide it,
    // because props.onClose() would just hide both disclaimer types
    if (this.isAfterHoursPopup()) {
      this.hideAfterHours()
      return true
    }

    this.props.onClose()
  }

  submitModal = () => {
    this.props.onSubmit()
  }

  hideAfterHours = () => {
    this.setState({
      showAfterHours: false,
    })
  }

  isAfterHoursPopup = () => {
    const { skipAfterHoursCheck } = this.props
    const { afterHoursMessage, showAfterHours } = this.state
    return !!(afterHoursMessage && showAfterHours && skipAfterHoursCheck !== true)
  }

  isCustomMessageFromProp = () => {
    return !!(
      typeof this.props.showCustomMessage !== 'undefined' &&
      this.props.showCustomMessage === true &&
      typeof this.props.customMessageFromProp !== 'undefined' &&
      this.props.customMessageFromProp !== ''
    )
  }

  renderDisclaimerContent = () => {
    const { loading, submitButtonText } = this.props
    const { afterHoursMessage, disclaimerMessage, isLoading } = this.state

    if (isLoading) {
      return <Loader styleVariation='staticWithHeight' />
    }

    if (this.isAfterHoursPopup()) {
      return (
        <React.Fragment>
          <Text align={'center'} fontWeight={'bold'} fontSize={20}>
            <FormattedMessage id='app.disclaimer.awayNotice' defaultMessage='Away notice' />
          </Text>
          <Text
            align={'center'}
            fontSize={16}
            mt={'8px'}
            opacity={0.5}
            className={styles.multiLineText}
          >
            {afterHoursMessage}
          </Text>
          <Button
            mt={'24px'}
            isFullWidth
            loading={loading}
            onClick={this.hideAfterHours}
            data-qa='button-submit-after-hours'
          >
            <FormattedMessage id='app.disclaimer.gotIt' defaultMessage='Got it' />
          </Button>
        </React.Fragment>
      )
    }

    let { countryIsoCode } = this.props

    return (
      <React.Fragment>
        <Text align={'center'} fontWeight={'bold'} fontSize={20}>
          <FormattedMessage
            id='app.disclaimer.headline'
            description='Disclaimer headline'
            defaultMessage='Disclaimer'
          />
        </Text>
        {this.isCustomMessageFromProp() ? (
          <Text className={styles.customDisclaimerMessage}>
            <HtmlMarkdown>{this.props.customMessageFromProp}</HtmlMarkdown>
          </Text>
        ) : disclaimerMessage ? (
          <Text className={styles.customDisclaimerMessage}>
            <HtmlMarkdown>{disclaimerMessage}</HtmlMarkdown>
          </Text>
        ) : (
          <div>
            <Text align={'center'} fontSize={16} mt={'8px'} mb={'24px'} opacity={0.5}>
              <FormattedMessage
                id='app.disclaimer.body'
                description='Disclaimer paragraph 1'
                defaultMessage='Please note: You cannot add, make changes, or bind any insurance coverages directly from the app.'
              />
              <FormattedMessage
                id='app.disclaimer.body2'
                description='Disclaimer paragraph 2'
                defaultMessage='This form of change request is a notification-only method.'
              />
              {countryIsoCode && countryIsoCode.toLowerCase() === 'us' ? (
                <FormattedMessage
                  id='app.disclaimer.body3us'
                  description='Disclaimer paragraph 3us'
                  defaultMessage='You must receive digital, written or verbal communication from one of our insurance agents.'
                />
              ) : (
                <FormattedMessage
                  id='app.disclaimer.body3'
                  description='Disclaimer paragraph 3'
                  defaultMessage='You must receive digital, written or verbal communication from one of our insurance brokers.'
                />
              )}
            </Text>
          </div>
        )}
        <Button
          mt={'24px'}
          isFullWidth
          isLoading={loading}
          onClick={this.submitModal}
          data-qa='button-submit-disclaimer'
        >
          {submitButtonText ? (
            submitButtonText
          ) : (
            <FormattedMessage id='app.continue' defaultMessage='Continue' />
          )}
        </Button>
      </React.Fragment>
    )
  }

  render() {
    const { isWidget, visible } = this.props

    // NOTE: we can't show modal in widget mode
    // so we are gonna render content as full screen page
    if (isWidget) {
      if (!visible) {
        return ''
      }
      return (
        <div>
          <div className={styles.widgetModalBackdrop} onClick={this.closeModal} />
          <div className={styles.widgetModal}>
            <span onClick={this.closeModal} className={styles.closeWidgetModalIconHolder}>
              <SvgIcon type='RemoveThinner' className={styles.closeWidgetModalIcon} />
            </span>
            <div className={styles.widgetModalContent}>{this.renderDisclaimerContent()}</div>
          </div>
        </div>
      )
    }

    return (
      <Modal
        isOpen={visible}
        isCentered
        className={styles.pwaModal}
        closable={true}
        footer={null}
        onOk={this.submitModal}
        onClose={this.closeModal}
        renderContent={this.renderDisclaimerContent}
        getContainer={() => getBodyContainer()}
      >
        {/* <div className={styles.pwaModalContent}>
          {this.renderDisclaimerContent()}
        </div> */}
      </Modal>
    )
  }
}

const DisclaimerContext = props => (
  <WidgetContext.Consumer>
    {context => <Disclaimer {...props} {...context} />}
  </WidgetContext.Consumer>
)

export default DisclaimerContext
